import { Box, CircularProgress, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { EntityField } from './entityField';

interface EntityEditModalProps {
  open: boolean;
}

export const EntityEditModal = observer(({ open }: EntityEditModalProps) => {
  const { docReviewStoreV2 } = useStore();
  const { entityReviewFormStore } = docReviewStoreV2;

  useEffect(() => {
    if (open) docReviewStoreV2.loadEntityEditForm();
  }, [open]);

  if (entityReviewFormStore.loading) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {entityReviewFormStore.items.map(item => (
        <Grid item xs={12} key={item.itemName}>
          <EntityField store={entityReviewFormStore} item={item} />
        </Grid>
      ))}
    </Grid>
  );
});
